var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getApiClient } from "../../services/AxiosClients";
import DeliveryMethodDomainService from "../Domain/DeliveryMethod/DeliveryMethod.service";
export default class DeliveryMethodeService {
    static searchAll(search) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/deliveryMethods/search/findByNameLike", {
                params: { search },
            });
            return response.data._embedded.deliveryMethods;
        });
    }
    static searchForMessageTab(search) {
        return __awaiter(this, void 0, void 0, function* () {
            const allowedMethods = [
                DeliveryMethodDomainService.EMAIL,
                DeliveryMethodDomainService.SMS,
                DeliveryMethodDomainService.EMAIL_NOTIFICATION,
            ];
            const resp = yield DeliveryMethodeService.findByIds(allowedMethods);
            return resp.filter((method) => method.displayName
                .toLocaleLowerCase()
                .includes(search.toLocaleLowerCase()));
        });
    }
    static findByIds(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/deliveryMethods/search/findByIdIn", {
                params: { ids: ids.join(",") },
            });
            return response.data._embedded.deliveryMethods;
        });
    }
}
